module.exports = __webpack_public_path__ + "static/media/v05-01.cccdcf50.png";